import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SeoService } from './core/services/seo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  // Injeta o SEO Service para inicializar no bootstrap da aplicação
  private seoService = inject(SeoService);

  ngOnInit() {
    // Configura SEO padrão e Schema.org da organização
    this.seoService.resetToDefault();
  }
}
